import React, { useCallback, useState } from "react";

import { Button, Flex, Typography } from "antd";
import { useDispatch } from "react-redux";

import { useTranslation } from "react-i18next";

import useTimer from "../../../../hooks/useTimer";

import { AuthActions } from "../../../../auth/actions";

function SuccessRegisterView() {
  const [version, setVersion] = useState(0);
  const { t } = useTranslation("translations");
  const dispatch = useDispatch();
  const { minutes, seconds, secondsLeft } = useTimer(5, version);

  const handleResendRegisterEmail = useCallback(() => {
    dispatch(AuthActions.resendRegisterEmail());
    setVersion((x) => x + 1);
  }, [dispatch]);

  return (
    <Flex vertical align="flex-start" gap="middle">
      <Typography.Text>{t("new_password_sent_on_email")}</Typography.Text>
      {secondsLeft > 0 && (
        <Typography.Text type="secondary">
          {t("resending_possible_after")} {minutes}:{seconds}
        </Typography.Text>
      )}
      <Button type="text" onClick={handleResendRegisterEmail} disabled={secondsLeft > 0}>
        {t("send_email_again")}
      </Button>
    </Flex>
  );
}

export default React.memo(SuccessRegisterView);
